import React from "react";

import classnames from "classnames";
import formatCurrency from "Utils/formatCurrency";

import { Modal, StandaloneTrigger, ModalBody, ModalTitle, ModalHeader, ModalFooter } from "Cobalt/Modal";
import { Table, TR, TH, TD, HeaderTR } from "Cobalt/TableV2";
import Button from "Theme/Button";

const EnrolledEmployeesModal = ({ plan, ...rest }) => {
  const rows = plan.employee_cost_breakdowns.map(employeeBreakdownToRow);
  return (
    <Modal {...rest}>
      <ModalHeader closeButton>
        <ModalTitle>Employee Costs Breakdown</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Table>
          <thead>
            <HeaderTR>
              <TH>Employee</TH>
              <TH>Age</TH>
              <TH align="right">Employee Share</TH>
              <TH align="right">Company Share</TH>
              <TH align="right">Total Cost</TH>
            </HeaderTR>
          </thead>
          <tbody>
            {rows.map((employee, index) => {
              const { name, age, employeeShare, companyShare, totalCost } = employee;
              return (
                <TR key={`row_${index}`} withBorder={index < rows.length - 1}>
                  <TD>{name}</TD>
                  <TD>{age}</TD>
                  <TD align="right">{formatCurrency(employeeShare, 2)}</TD>
                  <TD align="right">{formatCurrency(companyShare, 2)}</TD>
                  <TD align="right">{formatCurrency(totalCost, 2)}</TD>
                </TR>
              );
            })}
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => rest.onHide()}>Close</Button>
      </ModalFooter>
    </Modal>
  );
};

const employeeBreakdownToRow = (breakdown) => {
  const { name, age, employee_premium, dependents_premium, company_contribution: companyShare, number_of_dependents } = breakdown;
  const totalCost = employee_premium + dependents_premium;
  const employeeShare = totalCost - companyShare;
  return {
    name: classnames(name, {
      "+ 1 dependent": number_of_dependents === 1,
      [`+ ${number_of_dependents} dependents`]: number_of_dependents > 1,
    }),

    age,
    employeeShare,
    companyShare,
    totalCost,
  };
};

export const EnrolledEmployeesModalTrigger = ({ plan, triggerText = "See Costs For All Employees" }) => (
  <StandaloneTrigger
    trigger={(props) => (
      <Button color="tertiary" intuitProps={{ color: "link" }} classicProps={{ color: "link" }} px={0} {...props}>
        {triggerText}
      </Button>
    )}
    modal={(props) => <EnrolledEmployeesModal plan={plan} {...props} />}
  />
);

export default EnrolledEmployeesModal;
